import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedLpnIndexController extends Controller {
  @tracked page = 1;
  @tracked limit = 50;
  @tracked search = '';
  @tracked savings: string[] = [];
  @tracked format: string[] = [];
  @tracked programs: string[] = [];
  @tracked areasOfStudy: string[] = [];

  queryParams = ['page', 'limit', 'search', 'savings', 'format', 'programs', 'areasOfStudy'];
}
